<template>
  <div class="role_container">
    <div class="sel">
      <a-select
        mode="multiple"
        placeholder="请选择"
        :value="selectedItems"
        :open="selectOpen"
        style="width: 200px"
        @change="handleChange"
      >
        <a-select-option v-for="item in this.filteredOptions" :key="item[configData.primaryKey]" >
          {{ item[configData.displayKey] }}
        </a-select-option>
      </a-select>
    </div>
    <div class="but">
        <a-button @click="modelVisible(true)">选择</a-button>
    </div>
    <div>

     <select-component-model
                  :closeModel="modelVisible"
                  @selectSubmit="selectSubmit"
                  ref="modelList"
                  :configData="configData"
                  :fatcherSelectedItems="selectedItems"
                  :multiple="multiple"
      />

    </div>
  </div>
</template>
<script>
import SelectComponentModel from '@/components/jeecgbiz/customComponnent/SelectComponentModel'

export default {
  components: {
    SelectComponentModel
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    configData: {
      type: Object,
      default: null
    },
    multiple: {
      type: Boolean,
      default: true
    }
  }
  ,

  data() {
    return {
      selectOpen:false,//是否开启下拉选择框
      selectedItems: [],
      options:[]

    };
  },created() {
    // console.log("value:",this.value)
    this.selectedItems=this.value;
    /*this.selectedItems=[
      "hl0001",
      "yyy",
      "1506096703841812482"
    ];*/
  },
  computed: {
    filteredOptions() {
     // console.log("OPTIONS.filter(o => !this.selectedItems.includes(o)):",OPTIONS.filter(o => !this.selectedItems.includes(o)))
      //return OPTIONS.filter(o => !this.selectedItems.includes(o));
      return this.options;
    },
  },
  methods: {
    handleChange(selectedItems) {
      // console.log("selectedItems,",selectedItems)

      this.selectedItems = selectedItems;
      this.$emit('input',  this.selectedItems);
    },
    modelVisible(){
      this.$refs.modelList.modelShow(true);
    },
    selectSubmit(selectData){
      //console.log("selectData:",selectData);
      this.options=selectData;
      this.selectedItems=[];
      for (const item of selectData) {
        this.selectedItems.push(item[this.configData.primaryKey]);
      }
     /* console.log("selectSubmit this.selectedItems:",this.selectedItems)
      this.$emit('select',  ['11']);*/
      this.$emit('input',  this.selectedItems);
    }
  },
};
</script>
<style scoped>
  .role_container{
    display: flex;
  }
  .but{
    margin-left: 20px;
  }
</style>